import { Button, FormControl, TextField, Typography } from '@mui/material';
import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import login from '../images/login-bg.jpg';
import logo from '../images/logo.png';

export default class Login extends React.Component<{}, {}> {
    _userName: string = '';
    _password: string = '';

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <video autoPlay muted loop id='videoLogin'>
                    <source src='/ad735_login_video_2.mp4' type="video/mp4"/>
                </video>
                <div className='card middle zTop' style={{width: '400px', padding: '20px'}}>
                    <img src={logo} className='logo'/>
                    <FormControl fullWidth style={{marginBottom: '20px'}}>
                        <TextField label="Usuario" variant="standard" onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                            this._userName = event.currentTarget.value;
                        }}/>
                    </FormControl>
                    <FormControl fullWidth style={{marginBottom: '20px'}}>
                        <TextField type="password" label="Contraseña" variant="standard" onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                            this._password = event.currentTarget.value;
                        }}/>
                    </FormControl>
                    <div style={{textAlign: 'right'}}>
                        <Button variant='contained' onClick={this.Login.bind(this)}>Iniciar sesión</Button>
                    </div>
                </div>
            </React.Fragment>
            
        )
    }

    private Login(): void {
        var user = {
            username: this._userName,
            password: this._password
        };

        var settings = {
            url: `${Common.END_POINT}/login`,
            type: "POST",
            data: JSON.stringify(user),
            dataType: "json",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        };
          
        $.ajax(settings).done((response: any) => {
            localStorage.setItem('user', JSON.stringify(response));
            if(!Common.IsNullOrEmpty(Common.getUrlParam("source"))) {
                window.location.href = Common.getUrlParam("source");
            }
            else {
                window.location.href = "/"
            }
        });
    }
}